/**
 * ExplainerModals - state-aware truthful explainers (GOAL_P0b)
 *
 * Two thin wrappers over BobyModal. ALL explainer copy lives in this one file.
 * Wired by: CircleManagementPage (state b), PlantSeedsPage + MemberChatModal (state c).
 */

import { useNavigate } from 'react-router-dom';
import BobyModal from './BobyModal';

interface ExplainerModalProps {
    isOpen: boolean;
    onClose: () => void;
}

// INTERIM until 5.8 - circles.js gets shared verifyOwner, 404 dies at source
// (verified via Crevon 30 Jul: Circles 404 → Nurture → Circles loads)
export function StillActivatingModal({ isOpen, onClose }: ExplainerModalProps) {
    const navigate = useNavigate();

    return (
        <BobyModal
            variant="confirm"
            isOpen={isOpen}
            onClose={onClose}
            title="Your Kaksos is still activating"
            message="Your Kaksos is still finishing activation, so your circles aren't ready yet. Open your Nurture page once, then come back here, and your circles will load."
            confirmLabel="Go to Nurture"
            cancelLabel="Close"
            onConfirm={() => navigate('/nurture')}
        />
    );
}

export function NoApiKeyModal({ isOpen, onClose }: ExplainerModalProps) {
    const navigate = useNavigate();

    return (
        <BobyModal
            variant="confirm"
            isOpen={isOpen}
            onClose={onClose}
            title="Your Kaksos needs an API key"
            message="To chat with your Kaksos, add your Anthropic API key under Settings → API Key. Once it's saved, your Kaksos can respond here."
            confirmLabel="Go to Settings"
            cancelLabel="Close"
            onConfirm={() => navigate('/settings')}
        />
    );
}
